import { connect } from 'react-redux';

import { preserveStubsUrl } from 'utils/general';
import {
  GROCERIES_OFFERS,
  SEASONAL,
  SLOT_BUTTON,
  MY_DETAILS,
  LOYALTY,
  DELIVERY_PASS_ACTIVE,
  DELIVERY_PASS_AVAILABLE,
} from 'constants/categoryIds';

import { getCategoryById, getCategoryBannerById } from 'redux/modules/taxonomy/selectors';
import { getMegaMenuMenus, getMegaMenuActiveLevel } from 'redux/modules/page/selectors/mega-menu';
import { getMegaMenuHistory, getPathForMegaMenuItemById } from 'redux/modules/mega-menu/selectors';
import { hasBookedSlot } from 'redux/modules/customer-slot/selectors';
import { getEditSlotUrl } from 'redux/modules/slot-booking/selectors/get-edit-slot-url';
import { getExperienceFragmentPageTitle } from 'redux/modules/experience-fragments/selectors';
import { SEASONAL_MENU } from 'constants/experience-fragments';
import urls from 'constants/urls';
import MenuLink from './MenuLink';

export default connect((state, props) => {
  const { generated, id, maxMenus, offer = false } = props;

  let {
    emptyOfProducts = false,
    hiddenInNav = false,
    hasDescendants = false,
    iconName: icon,
    name,
    url,
  } = props;
  let isOffer = false;

  if (!generated) {
    const category = getCategoryById(state, id) || {};
    ({ emptyOfProducts } = category);
    ({ hasDescendants } = category);
    ({ hiddenInNav } = category);
    icon = category.iconName;
    isOffer = category.offer || false;
    ({ name } = category);
    ({ url } = category);
  }

  if (id === GROCERIES_OFFERS) {
    name = 'Groceries OFFERS';
  }

  if (id === SLOT_BUTTON && !hasBookedSlot(state)) {
    name = 'Book Slot';
  }

  if (id === SLOT_BUTTON && hasBookedSlot(state)) {
    icon = 'CalendarBooked';
    name = 'Change Slot';
    url = getEditSlotUrl(state);
  }

  if (id === SEASONAL) {
    name = getExperienceFragmentPageTitle(state, SEASONAL_MENU.key);
  }

  if (id === MY_DETAILS) {
    icon = 'User';
    name = 'Account overview';
    url = preserveStubsUrl(urls.myAccount);
  }

  const path = url ?? getPathForMegaMenuItemById(state, id);
  const pathname =
    typeof path === 'string'
      ? path
      : path?.pathname && `${path?.pathname}${path?.search ? path.search : ''}`;

  const renderAsAnchor =
    id === MY_DETAILS ||
    id === LOYALTY ||
    id === DELIVERY_PASS_ACTIVE ||
    id === DELIVERY_PASS_AVAILABLE ||
    pathname?.includes('ecom/shop/browse/');

  return {
    display: !emptyOfProducts && !hiddenInNav,
    hasDescendants: hasDescendants && getMegaMenuHistory(state).length < maxMenus,
    icon,
    name,
    menus: getMegaMenuMenus(state),
    level: getMegaMenuActiveLevel(state),
    offer: offer || isOffer,
    path: pathname,
    banner: getCategoryBannerById(state, id),
    renderAsAnchor,
  };
})(MenuLink);
